import { Injectable } from '@angular/core';
import { ModelService } from './model.service';
import { AwareHttpService } from '@appbolaget/aware-http';
import { Category } from '@appbolaget/aware-model';

@Injectable()
export class CategoryService extends ModelService<Category> {
    model: Category = new Category();

    constructor(protected api: AwareHttpService) {
        super(api);
    }
}
